import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Search, Package, TrendingDown, RotateCcw, ShoppingCart, Trash2, Download, Undo2, ArrowRightLeft } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

export default function EstoqueCarroPage() {
  const [estoques, setEstoques] = useState([]);
  const [carros, setCarros] = useState([]);
  const [carroSelecionado, setCarroSelecionado] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogVenda, setDialogVenda] = useState(false);
  const [dialogDevolucao, setDialogDevolucao] = useState(false);
  const [dialogLimpar, setDialogLimpar] = useState(false);
  const [dialogRetornar, setDialogRetornar] = useState(false);
  const [retornando, setRetornando] = useState(false);
  const [dialogTransferir, setDialogTransferir] = useState(false);
  const [carroDestino, setCarroDestino] = useState("");
  const [transferindo, setTransferindo] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isVendedor = user.tipo === 'vendedor';
  
  console.log('Dados do usuário:', user);
  console.log('É vendedor?', isVendedor);
  console.log('Carro ID:', user.carro_id);

  const [formVenda, setFormVenda] = useState({
    quantidade: ""
  });

  const [formDevolucao, setFormDevolucao] = useState({
    quantidade: "",
    motivo: ""
  });

  const loadCarros = async () => {
    try {
      const response = await axios.get(`${API}/carros`);
      const carrosData = response.data;
      console.log('Carros carregados:', carrosData);
      setCarros(carrosData);
      
      // Se vendedor, selecionar automaticamente seu carro
      if (isVendedor && user.carro_id) {
        console.log('Selecionando carro do vendedor:', user.carro_id);
        setCarroSelecionado(user.carro_id);
      } else if (carrosData.length > 0 && !isVendedor) {
        // Admin seleciona o primeiro carro por padrão
        console.log('Admin - selecionando primeiro carro:', carrosData[0].id);
        setCarroSelecionado(carrosData[0].id);
      }
    } catch (error) {
      console.error("Erro ao carregar carros:", error);
      toast.error("Erro ao carregar carros");
    }
  };

  const loadEstoque = async () => {
    if (!carroSelecionado) {
      console.log('Nenhum carro selecionado ainda');
      return;
    }
    
    console.log('Carregando estoque do carro:', carroSelecionado);
    
    try {
      const response = await axios.get(`${API}/estoques/carro/${carroSelecionado}`);
      console.log('Estoque carregado:', response.data);
      setEstoques(response.data);
    } catch (error) {
      console.error("Erro ao carregar estoque:", error);
      toast.error("Erro ao carregar estoque do carro");
    }
  };

  useEffect(() => {
    loadCarros();
  }, []);

  useEffect(() => {
    if (carroSelecionado) {
      loadEstoque();
    }
  }, [carroSelecionado]);

  const handleVendaClick = (estoque) => {
    setProdutoSelecionado(estoque);
    setFormVenda({ quantidade: "" });
    setDialogVenda(true);
  };

  const handleDevolucaoClick = (estoque) => {
    setProdutoSelecionado(estoque);
    setFormDevolucao({ quantidade: "", motivo: "" });
    setDialogDevolucao(true);
  };

  const handleSubmitVenda = async (e) => {
    e.preventDefault();
    
    try {
      await axios.post(`${API}/movimentacoes`, {
        produto_id: produtoSelecionado.produto_id,
        tipo: "venda_carro",
        quantidade: parseInt(formVenda.quantidade),
        carro_id_origem: carroSelecionado,
        motivo: "Venda"
      });

      toast.success("Venda registrada com sucesso!");
      setDialogVenda(false);
      loadEstoque();
    } catch (error) {
      const message = error.response?.data?.detail || "Erro ao registrar venda";
      toast.error(message);
    }
  };

  const handleSubmitDevolucao = async (e) => {
    e.preventDefault();
    
    try {
      await axios.post(`${API}/movimentacoes`, {
        produto_id: produtoSelecionado.produto_id,
        tipo: "devolucao_carro",
        quantidade: parseInt(formDevolucao.quantidade),
        carro_id_origem: carroSelecionado,
        motivo: formDevolucao.motivo
      });

      toast.success("Devolução realizada com sucesso!");
      setDialogDevolucao(false);
      loadEstoque();
    } catch (error) {
      const message = error.response?.data?.detail || "Erro ao devolver produto";
      toast.error(message);
    }
  };

  const handleLimparEstoque = async () => {
    try {
      const response = await axios.post(`${API}/estoques/carro/${carroSelecionado}/limpar`);
      toast.success(response.data.message);
      setDialogLimpar(false);
      loadEstoque();
    } catch (error) {
      const message = error.response?.data?.detail || "Erro ao limpar estoque";
      toast.error(message);
    }
  };

  const handleRetornarParaLoja = async () => {
    if (!carroSelecionado) return;
    setRetornando(true);
    try {
      const response = await axios.post(`${API}/estoques/carro/${carroSelecionado}/retornar-para-loja`);
      toast.success(response.data.message);
      setDialogRetornar(false);
      loadEstoque();
    } catch (error) {
      const message = error.response?.data?.detail || "Erro ao retornar estoque para a loja";
      toast.error(message);
    } finally {
      setRetornando(false);
    }
  };

  const handleTransferirParaCarro = async () => {
    if (!carroSelecionado || !carroDestino) return;
    if (carroDestino === carroSelecionado) {
      toast.error("Selecione um carro de destino diferente do atual");
      return;
    }
    setTransferindo(true);
    try {
      const response = await axios.post(
        `${API}/estoques/carro/${carroSelecionado}/transferir-para-carro/${carroDestino}`
      );
      toast.success(response.data.message);
      setDialogTransferir(false);
      setCarroDestino("");
      loadEstoque();
    } catch (error) {
      const message = error.response?.data?.detail || "Erro ao transferir estoque";
      toast.error(message);
    } finally {
      setTransferindo(false);
    }
  };

  const handleDownloadPDF = async () => {
    if (!carroSelecionado) {
      toast.error("Selecione um carro primeiro");
      return;
    }
    
    try {
      const response = await axios.get(`${API}/estoques/carro/${carroSelecionado}/pdf`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const carroNome = carros.find(c => c.id === carroSelecionado)?.nome || "carro";
      link.setAttribute('download', `estoque_carro_${carroNome.replace(/\s+/g, '_')}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success("PDF baixado com sucesso!");
    } catch (error) {
      toast.error("Erro ao baixar PDF");
    }
  };

  const carroNome = carros.find(c => c.id === carroSelecionado)?.nome || "";

  const estoquesFiltrados = estoques.filter(est => {
    if (!searchQuery.trim()) return true;
    const termo = searchQuery.toLowerCase();
    return (
      est.produto_nome.toLowerCase().includes(termo) ||
      est.produto_codigo.toLowerCase().includes(termo)
    );
  });

  const valorTotalEstoque = estoquesFiltrados.reduce((acc, est) => 
    acc + (est.quantidade * (est.preco_venda || 0)), 0
  );

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-bold" style={{fontFamily: 'Work Sans'}}>Estoque do Carro</h2>
          <p className="text-gray-600 mt-1">
            {isVendedor ? "Gerencie o estoque do seu carro" : "Visualize o estoque dos carros"}
          </p>
        </div>
        <div className="flex gap-2">
          {carroSelecionado && (
            <Button
              onClick={handleDownloadPDF}
              variant="outline"
              className="gap-2"
            >
              <Download className="h-4 w-4" />
              Download PDF
            </Button>
          )}
          {!isVendedor && carroSelecionado && (
            <Button
              onClick={() => setDialogRetornar(true)}
              className="gap-2 bg-emerald-600 hover:bg-emerald-700 text-white"
              data-testid="btn-retornar-loja"
            >
              <Undo2 className="h-4 w-4" />
              Retornar Estoque para a Loja
            </Button>
          )}
          {!isVendedor && carroSelecionado && carros.length > 1 && (
            <Button
              onClick={() => { setCarroDestino(""); setDialogTransferir(true); }}
              className="gap-2 bg-blue-600 hover:bg-blue-700 text-white"
              data-testid="btn-transferir-carro"
            >
              <ArrowRightLeft className="h-4 w-4" />
              Transferir para outro Carro
            </Button>
          )}
          {!isVendedor && carroSelecionado && (
            <Button
              onClick={() => setDialogLimpar(true)}
              variant="destructive"
              className="gap-2"
            >
              <Trash2 className="h-4 w-4" />
              Limpar Estoque
            </Button>
          )}
        </div>
      </div>

      {/* Seleção de Carro e Busca */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex gap-4 items-end">
            {!isVendedor && (
              <div className="w-64">
                <Label htmlFor="carro">Selecionar Carro</Label>
                <select
                  id="carro"
                  value={carroSelecionado}
                  onChange={(e) => setCarroSelecionado(e.target.value)}
                  className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md"
                >
                  <option value="">Selecione um carro</option>
                  {carros.map((carro) => (
                    <option key={carro.id} value={carro.id}>
                      {carro.nome}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {isVendedor && (
              <div className="p-3 bg-blue-50 border border-blue-200 rounded-md">
                <p className="text-sm text-blue-700">Carro:</p>
                <p className="font-bold text-blue-900">{carroNome}</p>
              </div>
            )}

            <div className="flex-1">
              <Label htmlFor="search">Buscar produto</Label>
              <div className="relative mt-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  id="search"
                  placeholder="Digite o nome ou código..."
                  className="pl-10"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {carroSelecionado && (
        <>
          {/* Resumo */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Card>
              <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600">Total de Produtos</p>
                    <p className="text-3xl font-bold">{estoquesFiltrados.length}</p>
                  </div>
                  <Package className="h-10 w-10 text-blue-600" />
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600">Quantidade Total</p>
                    <p className="text-3xl font-bold">
                      {estoquesFiltrados.reduce((acc, est) => acc + est.quantidade, 0)}
                    </p>
                  </div>
                  <TrendingDown className="h-10 w-10 text-green-600" />
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600">Valor Total</p>
                    <p className="text-3xl font-bold text-green-600">
                      R$ {valorTotalEstoque.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </p>
                  </div>
                  <ShoppingCart className="h-10 w-10 text-green-600" />
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Lista de Produtos */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {estoquesFiltrados.map((estoque) => (
              <Card key={estoque.id} className="hover:shadow-md transition-shadow">
                <CardHeader className="pb-3">
                  <div className="flex-1">
                    <CardTitle className="text-lg">{estoque.produto_nome}</CardTitle>
                    <p className="text-sm text-gray-500 mt-1">SKU: {estoque.produto_codigo}</p>
                    {estoque.categoria && (
                      <p className="text-xs text-gray-400 mt-1">{estoque.categoria}</p>
                    )}
                  </div>
                </CardHeader>
                <CardContent className="space-y-3">
                  <div className={`text-center py-4 rounded-lg ${estoque.quantidade === 0 ? 'bg-red-50' : 'bg-blue-50'}`}>
                    <p className={`text-sm ${estoque.quantidade === 0 ? 'text-red-700' : 'text-blue-700'}`}>
                      {estoque.quantidade === 0 ? 'Estoque Zerado' : 'Quantidade Disponível'}
                    </p>
                    <p className={`text-4xl font-bold ${estoque.quantidade === 0 ? 'text-red-900' : 'text-blue-900'}`}>
                      {estoque.quantidade}
                    </p>
                  </div>

                  <div className="pt-2 border-t">
                    <div className="flex justify-between text-sm font-medium">
                      <span className="text-gray-600">Preço de Venda:</span>
                      <span className="text-green-600 text-lg">R$ {estoque.preco_venda?.toFixed(2)}</span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 text-xs text-gray-500">
                    <Package className="h-3 w-3" />
                    <span>Valor em estoque: R$ {(estoque.quantidade * (estoque.preco_venda || 0)).toFixed(2)}</span>
                  </div>

                  {/* Botões de Ação */}
                  <div className="flex gap-2 pt-2">
                    {!isVendedor && (
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleDevolucaoClick(estoque)}
                        className="w-full gap-1"
                        disabled={estoque.quantidade === 0}
                      >
                        <RotateCcw className="h-4 w-4" />
                        Devolver
                      </Button>
                    )}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {estoquesFiltrados.length === 0 && (
            <div className="text-center py-12">
              <Package className="h-12 w-12 mx-auto text-gray-400" />
              <p className="text-gray-500 mt-4">
                {searchQuery ? "Nenhum produto encontrado" : "Nenhum produto no estoque deste carro"}
              </p>
            </div>
          )}
        </>
      )}

      {!carroSelecionado && (
        <div className="text-center py-12">
          <Package className="h-12 w-12 mx-auto text-gray-400" />
          <p className="text-gray-500 mt-4">Selecione um carro para ver o estoque</p>
        </div>
      )}

      {/* Dialog Venda */}
      <Dialog open={dialogVenda} onOpenChange={setDialogVenda}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Registrar Venda</DialogTitle>
          </DialogHeader>
          {produtoSelecionado && (
            <form onSubmit={handleSubmitVenda} className="space-y-4">
              <div className="p-3 bg-blue-50 rounded">
                <p className="font-medium">{produtoSelecionado.produto_nome}</p>
                <p className="text-sm text-gray-600">SKU: {produtoSelecionado.produto_codigo}</p>
                <p className="text-sm text-gray-600">Disponível: {produtoSelecionado.quantidade}</p>
                <p className="text-sm font-medium text-green-600 mt-1">
                  Preço de venda: R$ {produtoSelecionado.preco_venda?.toFixed(2)}
                </p>
              </div>

              <div className="space-y-2">
                <Label htmlFor="quantidade_venda">Quantidade a Vender *</Label>
                <Input
                  id="quantidade_venda"
                  type="number"
                  min="1"
                  max={produtoSelecionado.quantidade}
                  required
                  value={formVenda.quantidade}
                  onChange={(e) => setFormVenda({...formVenda, quantidade: e.target.value})}
                  placeholder="Digite a quantidade"
                />
              </div>

              {formVenda.quantidade && (
                <div className="p-3 bg-green-50 border border-green-200 rounded">
                  <p className="text-sm text-green-700">Valor total da venda:</p>
                  <p className="text-2xl font-bold text-green-900">
                    R$ {(parseInt(formVenda.quantidade || 0) * (produtoSelecionado.preco_venda || 0)).toFixed(2)}
                  </p>
                </div>
              )}

              <div className="flex justify-end gap-2">
                <Button type="button" variant="outline" onClick={() => setDialogVenda(false)}>
                  Cancelar
                </Button>
                <Button type="submit" className="bg-green-600 hover:bg-green-700">
                  Confirmar Venda
                </Button>
              </div>
            </form>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Devolução */}
      <Dialog open={dialogDevolucao} onOpenChange={setDialogDevolucao}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Devolver para Loja</DialogTitle>
          </DialogHeader>
          {produtoSelecionado && (
            <form onSubmit={handleSubmitDevolucao} className="space-y-4">
              <div className="p-3 bg-blue-50 rounded">
                <p className="font-medium">{produtoSelecionado.produto_nome}</p>
                <p className="text-sm text-gray-600">SKU: {produtoSelecionado.produto_codigo}</p>
                <p className="text-sm text-gray-600">Disponível no carro: {produtoSelecionado.quantidade}</p>
              </div>

              <div className="space-y-2">
                <Label htmlFor="quantidade_dev">Quantidade a Devolver *</Label>
                <Input
                  id="quantidade_dev"
                  type="number"
                  min="1"
                  max={produtoSelecionado.quantidade}
                  required
                  value={formDevolucao.quantidade}
                  onChange={(e) => setFormDevolucao({...formDevolucao, quantidade: e.target.value})}
                  placeholder="Digite a quantidade"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="motivo_dev">Motivo da Devolução *</Label>
                <select
                  id="motivo_dev"
                  required
                  value={formDevolucao.motivo}
                  onChange={(e) => setFormDevolucao({...formDevolucao, motivo: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                >
                  <option value="">Selecione o motivo</option>
                  <option value="Produto com defeito">Produto com defeito</option>
                  <option value="Excesso de estoque">Excesso de estoque</option>
                  <option value="Retorno de cliente">Retorno de cliente</option>
                  <option value="Outro">Outro</option>
                </select>
              </div>

              <div className="flex justify-end gap-2">
                <Button type="button" variant="outline" onClick={() => setDialogDevolucao(false)}>
                  Cancelar
                </Button>
                <Button type="submit" className="bg-blue-600 hover:bg-blue-700">
                  Confirmar Devolução
                </Button>
              </div>
            </form>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Limpar Estoque */}
      <AlertDialog open={dialogLimpar} onOpenChange={setDialogLimpar}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmar Limpeza de Estoque</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza que deseja <strong>ZERAR TODO O ESTOQUE</strong> do carro <strong>{carroNome}</strong>?
              <br /><br />
              Esta ação irá:
              <ul className="list-disc ml-6 mt-2">
                <li>Definir a quantidade de TODOS os produtos para 0</li>
                <li>Não pode ser desfeita automaticamente</li>
              </ul>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleLimparEstoque}
              className="bg-red-600 hover:bg-red-700"
            >
              Sim, Limpar Estoque
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Dialog Retornar Estoque para a Loja */}
      <AlertDialog open={dialogRetornar} onOpenChange={setDialogRetornar}>
        <AlertDialogContent data-testid="dialog-retornar-loja">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2 text-emerald-700">
              <Undo2 className="h-5 w-5" /> Retornar Estoque para a Loja
            </AlertDialogTitle>
            <AlertDialogDescription>
              Confirma que deseja <strong>devolver TODO o estoque</strong> do carro{" "}
              <strong>{carroNome}</strong> de volta para o estoque da Loja?
              <br /><br />
              Esta ação irá:
              <ul className="list-disc ml-6 mt-2">
                <li>Somar TODAS as quantidades do carro ao estoque da Loja</li>
                <li>Zerar o estoque do carro</li>
                <li>Registrar uma movimentação de devolução para cada produto</li>
              </ul>
              <br />
              <span className="text-emerald-700 text-sm">
                Use isso quando o carro voltar da rota e você quer recolher tudo de volta para a loja de uma vez.
              </span>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={retornando}>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleRetornarParaLoja}
              disabled={retornando}
              className="bg-emerald-600 hover:bg-emerald-700"
              data-testid="btn-confirmar-retornar"
            >
              {retornando ? "Retornando..." : "Sim, retornar para a Loja"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Dialog Transferir Estoque entre Carros */}
      <AlertDialog open={dialogTransferir} onOpenChange={setDialogTransferir}>
        <AlertDialogContent data-testid="dialog-transferir-carro">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2 text-blue-700">
              <ArrowRightLeft className="h-5 w-5" /> Transferir Estoque para outro Carro
            </AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div>
                <p>
                  Escolha o carro de destino. TODO o estoque do carro{" "}
                  <strong>{carroNome}</strong> será transferido.
                </p>
                <div className="mt-3">
                  <Label htmlFor="sel-carro-destino" className="text-sm font-medium">Carro de destino</Label>
                  <select
                    id="sel-carro-destino"
                    value={carroDestino}
                    onChange={(e) => setCarroDestino(e.target.value)}
                    className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md bg-white text-sm"
                    data-testid="select-carro-destino"
                  >
                    <option value="">Selecione o carro de destino...</option>
                    {carros.filter(c => c.id !== carroSelecionado).map(c => (
                      <option key={c.id} value={c.id}>{c.nome}{c.placa ? ` — ${c.placa}` : ''}</option>
                    ))}
                  </select>
                </div>
                <div className="mt-3 text-sm">
                  Esta ação irá:
                  <ul className="list-disc ml-6 mt-1">
                    <li>Somar TODAS as quantidades ao estoque do carro selecionado</li>
                    <li>Zerar o estoque do carro <strong>{carroNome}</strong></li>
                    <li>Registrar uma movimentação de transferência por produto</li>
                  </ul>
                </div>
                <p className="text-blue-700 text-sm mt-3">
                  Útil quando o vendedor troca de carro ou você precisa realocar estoque sem passar pela Loja.
                </p>
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={transferindo}>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleTransferirParaCarro}
              disabled={transferindo || !carroDestino}
              className="bg-blue-600 hover:bg-blue-700"
              data-testid="btn-confirmar-transferir"
            >
              {transferindo ? "Transferindo..." : "Sim, transferir agora"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
